<template>
  <svg
    viewBox="0 0 24 24"
    fill="none" xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      :id="`mask_${id}`" style="mask-type: alpha;" maskUnits="userSpaceOnUse"
      x="3" y="3" width="18"
      height="19"
    >
      <path d="M15.9449 9.66665C15.2844 9.66665 14.7016 9.23457 14.5097 8.60255L13.4335 5.05915C13.0026 3.64035 10.9939 3.64035 10.563 5.05915L9.48683 8.60254C9.29488 9.23457 8.71209 9.66665 8.05156 9.66665H5.01711C3.55755 9.66665 2.9577 11.5397 4.14573 12.3876L6.66026 14.1822C7.18674 14.5579 7.41307 15.2288 7.22179 15.8467L6.18442 19.1977C5.75295 20.5914 7.36365 21.7184 8.52514 20.8354L11.0912 18.8846C11.6273 18.477 12.3694 18.4767 12.9059 18.8839L15.4858 20.8421C16.6475 21.7238 18.2569 20.5969 17.8256 19.2037L16.7861 15.8459C16.595 15.2284 16.8209 14.5579 17.3467 14.182L19.8579 12.3869C21.0448 11.5385 20.4445 9.66665 18.9856 9.66665H15.9449Z" fill="#EDC843" />
    </mask>
    <g :mask="`url(#mask_${id})`">
      <path d="M12.7159 5.2771L13.792 8.8205C14.08 9.76853 14.9541 10.4166 15.9449 10.4166H18.9856C19.715 10.4166 20.0152 11.3526 19.4217 11.7768L16.9106 13.5719C16.1218 14.1357 15.7829 15.1415 16.0697 16.0677L17.1091 19.4255C17.3248 20.1221 16.5201 20.6855 15.9393 20.2447L13.3593 18.2865C12.5546 17.6757 11.4415 17.6761 10.6373 18.2875L8.07123 20.2383C7.49049 20.6798 6.68514 20.1164 6.90088 19.4195L7.93824 16.0685C8.22516 15.1417 7.88567 14.1353 7.09595 13.5717L4.58142 11.7771C3.98741 11.3532 4.28733 10.4166 5.01711 10.4166H8.05156C9.04236 10.4166 9.91654 9.76853 10.2045 8.82049L11.2806 5.2771C11.4961 4.5677 12.5004 4.5677 12.7159 5.2771Z" stroke="#EDC843" stroke-width="1.5" />
      <path d="M12 4H3V22H12V4Z" fill="#EDC843" class="first-half" />
      <path d="M21 4H12V22H21V4Z" fill="#EDC843" class="second-half" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    id: { type: String, required: true },
  },
};
</script>
